export default "__VITE_ASSET__BlCS76P4__"